import { observable, makeObservable } from "mobx";

export default class VitalsStore {
  vitals;
  loading;

  constructor() {
    makeObservable(this, {
      vitals: observable,
      loading: observable,
    });
  }
}
